import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoginLayoutComponent } from './layouts/login-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeModule } from './home/home.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpInterceptorInterceptor } from './share/services/interceptor/http-interceptor.interceptor';
import { SharedModule } from './share/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddProductComponent } from './order-details/add-product/add-product.component';
import { ProductListComponent } from './order-details/product-list/product-list.component';
import { OrderOutComponent } from './order-details/order-out/order-out.component';
import { OrderListComponent } from './order-details/order-list/order-list.component';
import { AddMasterDataComponent } from './master-data-details/add-master-data/add-master-data.component';
import { MasterDataListComponent } from './master-data-details/master-data-list/master-data-list.component';
import { VehicleModelComponent } from './master-data-details/vehicle-model/vehicle-model/vehicle-model.component';
import { VehicleMakeComponent } from './master-data-details/vehicle-make/vehicle-make/vehicle-make.component';
import { VehicleMakeListComponent } from './master-data-details/vehicle-make-list/vehicle-make-list.component';
import { VehicleModelListComponent } from './master-data-details/vehicle-model-list/vehicle-model-list.component';
import { DealerDetailsComponent } from './dealer-details/add-dealer/dealer-details.component';
import { DealersListComponent } from './dealer-details/dealers-list/dealers-list.component';
import { TyreBrandComponent } from './master-data-details/tyre-brand/tyre-brand.component';
import { TyreBrandListComponent } from './master-data-details/tyre-brand-list/tyre-brand-list.component';
import { TyreModelListComponent } from './master-data-details/tyre-model-list/tyre-model-list.component';
import { TyreModelComponent } from './master-data-details/tyre-model/tyre-model.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { StockTransferToBranchComponent } from './order-details/stock-transfer-to-branch/stock-transfer-to-branch.component';
import { ReturnToDealerComponent } from './returns/return-to-dealer/return-to-dealer.component';
import { ReturnFromCustomerComponent } from './returns/return-from-customer/return-from-customer.component';
import { ReturnAndReplaceComponent } from './returns/return-and-replace/return-and-replace.component';
import { CapitalSpacePipe } from './share/pipes/capital-space.pipe';
import { ShortNumberPipe } from './share/pipes/short-number.pipe';
import { ServiceEntryComponent } from './order-details/service-entry/service-entry/service-entry.component';
import { ServiceListComponent } from './order-details/service-entry/service-list/service-list.component';
import { ViewImportStockListComponent } from './master-data-details/view-import-stock-list/view-import-stock-list.component';
import { NoLeadingSpacesDirective } from 'src/assets/no-leading-spaces';
import { SaleDealerComponent } from './order-details/sale-dealer/sale-dealer.component';
import { MasterDataComponent } from './master-data-details/master-data/master-data.component';
import { PendingTyrePatternComponent } from './master-data-details/pending-tyre-pattern/pending-tyre-pattern.component';
import { SkuLedgerComponent } from './ledgers/sku-ledger/sku-ledger.component';
import { PlotlyModule } from 'angular-plotly.js';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PerformanceInsightsComponent } from './ledgers/sku-ledger/performance-insights/performance-insights.component';
import { PerformanceSaleTrendsComponent } from './ledgers/sku-ledger/performance-insights/performance-sale-trends/performance-sale-trends.component';
import { PerformancePriceTrendsComponent } from './ledgers/sku-ledger/performance-insights/performance-price-trends/performance-price-trends.component';
import { PerformanceClosingBalanceComponent } from './ledgers/sku-ledger/performance-insights/performance-closing-balance/performance-closing-balance.component';
import { PerformanceSaleValueComponent } from './ledgers/sku-ledger/performance-insights/performance-sale-value/performance-sale-value.component';
import { PerformanceHighlightsComponent } from './ledgers/sku-ledger/performance-insights/performance-highlights/performance-highlights.component';
import { BuyerHistoryComponent } from './ledgers/sku-ledger/performance-insights/buyer-history/buyer-history.component';
import { DealerStopBuyingComponent } from './ledgers/sku-ledger/performance-insights/dealer-stop-buying/dealer-stop-buying.component';
import { PaymentAccountComponent } from './master-data-details/payment-account/payment-account.component';
import { OrdersExportListComponent } from './order-details/orders-export-list/orders-export-list.component';
import { DayBookComponent } from './day-book/day-book.component';
import { DayBookSalesComponent } from './day-book/day-book-sales/day-book-sales.component';
import { DayBookExpensesComponent } from './day-book/day-book-expenses/day-book-expenses.component';
import { DayBookServicesComponent } from './day-book/day-book-services/day-book-services.component';
import { StockMovementComponent } from './day-book/stock-movement/stock-movement.component';
import { NegativeStockComponent } from './day-book/negative-stock/negative-stock.component';
import { DayBookPaymentsComponent } from './day-book/day-book-payments/day-book-payments.component';
import { RisksAlertsComponent } from './day-book/risks-alerts/risks-alerts.component';
import { ExpenseCategoriesComponent } from './master-data-details/expense-categories/expense-categories.component';
import { ExpensesComponent } from './expenses/expenses.component';
import { ExpenseDetailComponent } from './expenses/expense-detail/expense-detail.component';
import { SkuMergeComponent } from './sku-merge/sku-merge.component';
import { BalanceAccountComponent } from './master-data-details/balance-account/balance-account.component';
import { BalanceAccountDetailComponent } from './master-data-details/balance-account/balance-account-detail/balance-account-detail.component';
import { SettlementsComponent } from './settlements/settlements.component';
import { DayPurchasesComponent } from './day-book/day-purchases/day-purchases.component';
import { DayReturnsFromCustomerComponent } from './day-book/day-returns-from-customer/day-returns-from-customer.component';
import { DayReturnsToDealerComponent } from './day-book/day-returns-to-dealer/day-returns-to-dealer.component';
import { DayTransfersFromBranchComponent } from './day-book/day-transfers-from-branch/day-transfers-from-branch.component';
import { DayTransfersToBranchComponent } from './day-book/day-transfers-to-branch/day-transfers-to-branch.component';
import { DayCashSummaryComponent } from './day-book/day-cash-summary/day-cash-summary.component';
import { CustomNumberPipe } from './share/pipes/custom-number.pipe';

PlotlyModule.plotlyjs = PlotlyJS;



@NgModule({ declarations: [
        AppComponent,
        LoginLayoutComponent,
        HomeLayoutComponent,
        HeaderComponent,
        FooterComponent,
        AddProductComponent,
        ProductListComponent,
        OrderOutComponent,
        OrderListComponent,
        AddMasterDataComponent,
        MasterDataListComponent,
        VehicleModelComponent,
        VehicleMakeComponent,
        VehicleMakeListComponent,
        VehicleModelListComponent,
        DealerDetailsComponent,
        DealersListComponent,
        TyreBrandComponent,
        TyreBrandListComponent,
        TyreModelListComponent,
        TyreModelComponent,
        StockTransferToBranchComponent,
        ReturnToDealerComponent,
        ReturnFromCustomerComponent,
        ReturnAndReplaceComponent,
        CapitalSpacePipe,
        ShortNumberPipe,
        ServiceEntryComponent,
        ServiceListComponent,
        ViewImportStockListComponent,
        NoLeadingSpacesDirective,
        SaleDealerComponent,
        MasterDataComponent,
        PendingTyrePatternComponent,
        SkuLedgerComponent,
        PerformanceInsightsComponent,
        PerformanceSaleTrendsComponent,
        PerformancePriceTrendsComponent,
        PerformanceClosingBalanceComponent,
        PerformanceSaleValueComponent,
        PerformanceHighlightsComponent,
        BuyerHistoryComponent,
        DealerStopBuyingComponent,
        PaymentAccountComponent,
        OrdersExportListComponent,
        DayBookComponent,
        DayBookSalesComponent,
        DayBookExpensesComponent,
        DayBookServicesComponent,
        StockMovementComponent,
        NegativeStockComponent,
        DayBookPaymentsComponent,
        RisksAlertsComponent,
        ExpenseCategoriesComponent,
        ExpensesComponent,
        ExpenseDetailComponent,
        SkuMergeComponent,
        BalanceAccountComponent,
        BalanceAccountDetailComponent,
        SettlementsComponent,
        DayPurchasesComponent,
        DayReturnsFromCustomerComponent,
        DayReturnsToDealerComponent,
        DayTransfersFromBranchComponent,
        DayTransfersToBranchComponent,
        DayCashSummaryComponent,
        CustomNumberPipe
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        HomeModule,
        FontAwesomeModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        InfiniteScrollDirective,
        PlotlyModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
